export class AppMenuOrderingRequestModel {
    constructor() {
        this.id = "";
        this.parentId = "";
    }
}
export class AppMenuOrderingRequest extends AppMenuOrderingRequestModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
